import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { integrationSchemaRegistry } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { AwsInspectorService } from '../../lib/constants';
import { InspectorService } from '../../service';

export type StatusReportConfig = typeof StatusReportConfig._.Config;

export const StatusReportConfig = IntegrationConfig.make({
  service: InspectorService,
  name: Integration_Handler_Names_Enum.StatusReport,
  configSchema: z.object({
    services: z
      .array(
        z.enum(AwsInspectorService).register(integrationSchemaRegistry, {
          i18n: 'integrations.aws.services.inspector.shared.inspector_service',
        }),
      )
      .optional(),
  }),
});
